import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {inject} from '@angular/core';
import {filter, Observable} from 'rxjs';
import {LinkActions} from '@link/store/link.actions-type';
import {selectKnowledgeDetail} from '@link/store/link.selector';
import {KnowledgeArticleDto} from '@server-models';

export const linkArticleResolver: ResolveFn<Observable<KnowledgeArticleDto | undefined>> = (route: ActivatedRouteSnapshot,
                                                                                            state: RouterStateSnapshot) => {
  const store: Store = inject(Store);
  const knowledgeArticleId = +(route.paramMap.get('id') ?? 0);

  store.dispatch(
    LinkActions.getKnowledgeArticle({
      knowledgeArticleId,
    })
  );

  return store.pipe(
    select(selectKnowledgeDetail),
    filter((data) => !!data)
  );
};
